/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import MDInput, { Props } from "dashboard-template/components/MDInput";
import { FC, forwardRef } from "react";
import { useMaterialUIController } from "context/ThemeContext";

/**
 * Wrapper component for Material Dashboard MDInput with dark mode support.
 * 
 * Features:
 * - Automatic dark mode styling synchronization
 * - Browser autofill styling override (maintains text visibility)
 * - Prevents autofill background color changes
 * - Adapts text color based on theme (white for dark, black for light)
 * 
 * @param props - MDInput properties (label, type, value, onChange, etc.)
 * @returns Styled input field component with theme integration
 */
const Input: FC<Props> = forwardRef((props, ref) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <MDInput className={`inputHelper ${darkMode ? "dark-mode" : "light-mode"}`}
      {...props}
      ref={ref}
    />
  );
});

export default Input;
